const $ = jQuery;
const swiperOptions = {
  effect: 'fade',
  autoplay: {
    delay: 4000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
  },
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

const initSwiperInstances = function initSwiperInstances(selector, options) {
  return Array.from(document.querySelectorAll(selector)).map((element) => {
    // Swiper 12 uses .swiper as the container class, while existing Drupal
    // content still provides the legacy .swiper-container class.
    element.classList.add('swiper');
    return new Swiper(element, options);
  });
};

const initSwiper = function initSwiper() {
  if (!$('.swiper-container').length) {
    return false;
  }
  var mySwiper = initSwiperInstances(
    '.swiper-container:not(.swiper-double-show)',
    swiperOptions,
  );

  for (let i = 0; i < mySwiper.length; i += 1) {
    if (mySwiper[i].el.classList.contains('no-autoplay')) {
      mySwiper[i].autoplay.stop();
    }
  }

  //PC mother horizontal
  initSwiperInstances('.block-field-blocknodeillumina-productfield-pc-body .swiper-double-show', {
    effect: 'slide',
    autoplay: {
      delay: 4000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 2,
    slidesPerGroup: 2,
  });

  //MB mother horizontal
  initSwiperInstances('.block-field-blocknodeillumina-productfield-mobile-body .swiper-double-show', {
    effect: 'slide',
    autoplay: {
      delay: 4000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

export default initSwiper;
